import WikiShowcaseSrc from 'assets/wiki-page/Coomunity.png'
import { pagesPathsEnum } from 'common/router/router.enum'
import { generateBasicSeoTags } from 'common/utils/seo'
import { useTranslation } from 'next-i18next'
import Head from 'next/head'
import Image from 'next/image'
import { getCommunityServerSideProps } from 'services/community/community.server'
import { getCommunityLayout } from 'services/community/community.layout'
import CommunityWikiList from 'services/community/components/CommunityWiki/CommunityWikiList'
import IndividualsFooter from 'services/landing-page-individuals/components/IndividualsFooter'
import IndividualsNavbar from 'services/landing-page-individuals/components/individualsNavbar'
import styled from 'styled-components'

const CommunityWiki = ({ isCandidate = false }: { isCandidate?: boolean }) => {
  const { t } = useTranslation('landing-page-company')

  return (
    <div>
      <Head>
        {generateBasicSeoTags({
          url: pagesPathsEnum.communityWiki,
          keywords: [
            'maritime community forum',
            'maritime discussion board',
            'ask maritime experts',
            'online maritime networking',
            'maritime industry Q&A',
            'join maritime community',
          ],
        })}
      </Head>

      <Div>
        {!isCandidate && (
          <div className="p-3">
            <IndividualsNavbar text="I'm an employer" />
          </div>
        )}

        <div className="w-full mx-auto px-2">
          <Image src={WikiShowcaseSrc} loading="eager" alt="Wiki showcase" className="w-full border-round-2xl" />
        </div>

        <CommunityWikiList />

        {!isCandidate && <IndividualsFooter t={t} />}
      </Div>
    </div>
  )
}

export const getServerSideProps = getCommunityServerSideProps

CommunityWiki.getLayout = getCommunityLayout

const Div = styled.div`
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
`

export default CommunityWiki
